import type { ReactNode } from 'react'
import { cx } from './utils/cx'

export function Label({ children, className }: { children?: ReactNode; className?: string }) {
  return <span className={cx('st-lbl', className)}>{children}</span>
}
